var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgMessage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "message_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.196 26.246l.522.303a14.508 14.508 0 007.276 1.951H15c7.88 0 14.292-6.278 14.295-13.995.002-3.74-1.484-7.255-4.183-9.9C22.413 1.958 18.824.5 15.006.5 7.12.5.707 6.778.704 14.494a13.745 13.745 0 002.186 7.448l.34.53-1.444 5.163 5.41-1.389zm16.469-7.736c-.107-.176-.394-.28-.824-.491-.43-.211-2.542-1.229-2.936-1.37-.394-.14-.68-.21-.967.211-.287.422-1.11 1.37-1.361 1.65-.25.28-.501.316-.931.105-.43-.21-1.815-.655-3.456-2.088-1.278-1.116-2.14-2.493-2.39-2.914-.251-.421-.027-.65.188-.859.193-.188.43-.491.644-.737.215-.246.287-.421.43-.702.143-.28.072-.526-.036-.737-.107-.21-.967-2.282-1.325-3.124-.349-.82-.703-.71-.967-.722-.25-.012-.537-.015-.823-.015-.287 0-.752.105-1.146.527-.394.42-1.505 1.439-1.505 3.51 0 2.07 1.54 4.07 1.755 4.351.215.281 3.03 4.53 7.342 6.353a25.04 25.04 0 002.45.886c1.03.32 1.966.275 2.707.167.825-.12 2.542-1.018 2.9-2 .358-.983.358-1.825.251-2.001z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.618-8.824H-9.707v47.332h48.325V-8.824z",
    fill: "url(#message_svg__paint0_linear_4292_9210)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "message_svg__paint0_linear_4292_9210",
    x1: 14.456,
    y1: 38.508,
    x2: 14.456,
    y2: -8.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25CF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61FD7D"
  })))));
}
export default SvgMessage;